module.exports = __webpack_public_path__ + "static/img/tevalis-logo.931497f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tevalis-logo.svg
// module id = X2On
// module chunks = 1